import * as React from 'react';
import PageMain from '../../components/Navigation/PageMain/PageMain';
import GeneralSettings from '../../components/Settings/GeneralSettings/GeneralSettings';
import useAsyncRequestGeneralSettings from '../../hooks/useAsyncRequestGeneralSettings';
import { RequestStatus } from '../../sic-lib/enums/RequestStatus';
import { TimeZoneSettings } from '../../sic-lib/types/GeneralSettings';

export default function GeneralSettingsPage() {
    const [generalSettings, setGeneralSettings] = React.useState<[TimeZoneSettings]>([
        {
            name: '',
            value: '',
            isAdmin: false,
            default: '',
            options: [],
        },
    ]);

    const { requestStatus, asyncRequestGeneralSettings } = useAsyncRequestGeneralSettings();

    React.useEffect(() => {
        async function request() {
            const asyncResult = await asyncRequestGeneralSettings({
                names: ['timezoneid'],
            });

            if (asyncResult) {
                setGeneralSettings(asyncResult);
            }
        }

        request();
    }, []);

    return (
        <PageMain
            pageTitle="General Settings"
            showError={requestStatus === RequestStatus.error}
            showLoading={requestStatus !== RequestStatus.success}
        >
            <div className="settingsPage">
                <div className="settingsPage__wrapper">
                    <GeneralSettings timeZone={generalSettings} />
                </div>
            </div>
        </PageMain>
    );
}
